if (typeof (Promise as any).withResolvers === 'undefined') {
	(Promise as any).withResolvers = function () {
		let resolve, reject;
		const promise = new Promise((res, rej) => {
			resolve = res;
			reject = rej;
		});
		return { promise, resolve, reject };
	};
}

import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';
import { createRoot } from 'react-dom/client';
import { initAnalytics } from './utils/analytics';
import { redactUrlSecrets } from './utils/redact-url-secrets';

import { pdfjs } from 'react-pdf';
import { createPdfWorkerSrc } from './config/pdf-worker';

// The worker runs through a wrapper that polyfills Promise.withResolvers first
// (see src/config/pdf-worker.ts); the worker file itself is resolved as before.
pdfjs.GlobalWorkerOptions.workerSrc = createPdfWorkerSrc(
	new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString(),
);

export { pdfOptions } from './config/pdf-options';

const config = {
	apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY,
	environment: 'production',
	revision: 'git SHA/project version',
};

const honeybadger = Honeybadger.configure(config);

// The public lineage route carries an access token in `?k=`. Honeybadger
// reports the current URL with every notice, so strip it before it leaves.
honeybadger.beforeNotify((notice) => {
	if (notice?.url) {
		notice.url = redactUrlSecrets(notice.url);
	}
});

initAnalytics();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
	<HoneybadgerErrorBoundary honeybadger={honeybadger}>
		<App />
	</HoneybadgerErrorBoundary>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

